import { render, staticRenderFns } from "./LegalsButtons.vue?vue&type=template&id=2bd56eba"
import script from "./LegalsButtons.vue?vue&type=script&lang=js"
export * from "./LegalsButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports